<template>
  <button @click="runScript">Run Python Script</button>
</template>

<script>
import axios from 'axios';

export default {
  methods: {
    runScript() {
      axios.get('http://localhost:5000/run-script')
        .then(response => {
          console.log(response.data);
        })
        .catch(error => {
          console.error(error);
        });
    }
  }
}
</script>

<style scoped>
button {
  margin: 20px;
  padding: 10px;
  font-size: 20px;
  cursor: pointer;
}
</style>